
function headerscroll(){
  var hh = $(window).innerHeight() - $('#header-menu').innerHeight();  
  $(window).scroll(function() {
    if($(this).scrollTop() < hh){
      
      $('#top-links').removeClass("top-out").addClass("top-fixed");
      $('#right-links').removeClass("right-fixed");
    }
    else{
      if($(this).scrollTop() >= hh && $(this).scrollTop() <= $(window).innerHeight()){
        $('#top-links').removeClass("top-fixed").addClass("top-out"); 
        $('#right-links').removeClass("right-fixed");
      }
      else{
        $('#right-links').addClass("right-fixed");        
      }
    }
  });
}

/* Home Carousel*/
function handleFlexCasousel(){
  var animate,text;  
    if ( $('.slides li').size() > 1 ) {
    $('.home-slideshow').flexslider({
      namespace: "velit-",
      slideshow: vl_slideshow,
      slideshowSpeed: vl_slideshowSpeed,
      directionNav: vl_directionNav,
      controlNav: vl_controlNav,
      pauseOnHover: vl_pauseOnHover,
      randomize: vl_randomize,
      smoothHeight: true,
      directionNav: true,
      prevText: "<i class='fa fa-angle-left'></i>",
      nextText: "<i class='fa fa-angle-right'></i>",
      start: function(){
        $('.home-slideshow-wrapper').css({"overflow":"","height":"" });
      	$('.home-slideshow').css("opacity","1"); 
        $('.home-slideshow-loader').hide();
      	$( ".home-slideshow .slides li" ).each(function() {  
     	 if($(this).hasClass("velit-active-slide")){
            $(this).children('a').addClass("animated moveToBack");
            $(this).children('div').removeClass("not-animated");
      		$(this).children('div').addClass("animated");
      		$(this).children('div').each(function() {
              if($(this).hasClass("action")){
                var $this = $(this);
                setTimeout(function(){
                  animate = $this.attr('data-velit-animate');
      			  $this.addClass(animate);
                  text = $this.attr('data-text');
                  $this.children('a').html("<span>"+text+"</span>");
                }, 1000);
              }
              else{
      			animate = $(this).attr('data-velit-animate');
      			$(this).addClass(animate);
      			text = $(this).attr('data-text');
      			$(this).html("<span>"+text+"</span>");
              }
    		});
    	 }
         else{
            $(this).children('a').removeClass("animated moveToBack");
            $(this).children('div').removeClass("animated");
      		$(this).children('div').each(function() {
              if($(this).hasClass("action")){
           		animate = $(this).attr('data-velit-animate');
      			$(this).removeClass(animate);
      			$(this).children('a').html("");
              }else{
                animate = $(this).attr('data-velit-animate');
      			$(this).removeClass(animate);
      			$(this).html("");
              }
            });
         }
    	});
      },
      after: function(){
      	$( ".home-slideshow .slides li" ).each(function() {
     	 if($(this).hasClass("velit-active-slide")){
            $(this).children('a').addClass("animated moveToBack");
            $(this).children('div').removeClass("not-animated");
      		$(this).children('div').addClass("animated");
            $(this).children('div').each(function() {
              if($(this).hasClass("action")){
                var $this = $(this);
                setTimeout(function(){
                  animate = $this.attr('data-velit-animate');
      			  $this.addClass(animate);
                  text = $this.attr('data-text');
                  $this.children('a').html("<span>"+text+"</span>");
                }, 1000);
              }
              else{
      			animate = $(this).attr('data-velit-animate');
      			$(this).addClass(animate);
              	text = $(this).attr('data-text');
      			$(this).html("<span>"+text+"</span>");
              }
    		});
    	 }
         else{
            $(this).children('a').removeClass("animated moveToBack");
            $(this).children('div').removeClass("animated");
            $(this).children('div').each(function() {
              if($(this).hasClass("action")){
           		animate = $(this).attr('data-velit-animate');
      			$(this).removeClass(animate);
      			$(this).children('a').html("");
              }else{
           		animate = $(this).attr('data-velit-animate');
      			$(this).removeClass(animate);
      			$(this).html("");
              }
            });
         }          
    	});
      }
    });

  }
}

function ModalNewsletter(){
  
  if ($.cookie('peacock-cookies')) {
  } else {
    $('#newsletter-popup').modal('toggle');
    $('.nl-wraper-popup').removeClass("velit-hidden").addClass("velit-show");
    $('.nl-wraper-popup').addClass('animated'); 
  }
  $.cookie('peacock-cookies', 'true', { expires: 7});
  
}

function FeatureRealated(){
  if($(".gallery-slider").length){
    $(".gallery-slider").owlCarousel({
      navigation : true,
      pagination: false,
      items: 3,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,3],
      itemsDesktopSmall : [979,3],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,2],
      itemsMobile : [360,2],
      navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    });
  }
  
  if($(".section-tab-content").length){
    $(".section-tab-content").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,3],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1],
      navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    });
  }
  
  if($(".realated-content").length){
    $(".realated-content").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,3],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1],
      navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    });
  }
  
  if($(".ob_content").length){
    $(".ob_content").owlCarousel({
      navigation : true,
      pagination: false,
      items: 6,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,6],
      itemsDesktopSmall : [979,4],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,2],
      itemsMobile : [360,1],
      navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    });
  }
  
  if($(".home-collection-inner").length){
    $(".home-collection-inner").owlCarousel({
      navigation : true,
      pagination: false,
      items: 4,
      slideSpeed : 200,
      paginationSpeed : 800,
      rewindSpeed : 1000,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,3],
      itemsTablet: [768,2],
      itemsTabletSmall: [540,1],
      itemsMobile : [360,1],
      navigationText: ['<i class="fa fa-angle-left" title="Previous" data-toggle="tooltip" data-placement="top"></i>', '<i class="fa fa-angle-right" title="Next" data-toggle="tooltip" data-placement="top"></i>']
    });
  }
}

$(window).ready(function($){
  FeatureRealated();
  handleFlexCasousel();
});
   
$(window).load(function() {  
  ModalNewsletter();
  headerscroll();
  
});